var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPickuplocationcomponent = function SvgPickuplocationcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 8.5A6.67 6.67 0 0 1 8 1.833 6.67 6.67 0 0 1 14.667 8.5 6.67 6.67 0 0 1 8 15.167 6.67 6.67 0 0 1 1.333 8.5Zm1.334 0A5.332 5.332 0 0 0 8 13.833 5.332 5.332 0 0 0 13.333 8.5 5.332 5.332 0 0 0 8 3.167 5.332 5.332 0 0 0 2.667 8.5Z",
    fill: "#413E3B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 2,
    fill: "#413E3B"
  })));
};
export default SvgPickuplocationcomponent;